<template>
	<div class="wrap">
		<div class="insidebanner">
			<img src="../assets/partner/38201876_l.png" alt="">
			<span class="insidebanner-bor"></span>
		</div>
		<div class="content">
			<div class="content-btor"></div>
			<div class="intro">
				<div class="cwidth">
					<div class="intro-l">
						<div class="intro-txt">
							<div class="partitle">
								<h4>合伙人业务介绍</h4>
								<img src="../assets/partner/partner_introduction.png" alt="">
							</div>
							<p>KA幼教合伙人业务，围绕着Etonkids 3C价值教育理念，将Etonkids 17年自营高端园所的经验和百年蒙台梭利教育在中国本土化探索的成果惠及到国内广大幼儿园，提供权威的国际化、品质化、系统化、个性化的一站式服务，让更多的孩子可以享受到与Etonkids一样的国际化高品质的教育与服务。</p>
						</div>
						<img src="../assets/partner/1357.png" alt="">
					</div>
					<ul class="intro-r">
						<li class="one">
							<p>(1个) 幼教合伙人平台</p>
						</li>
						<li class="three">
							<p>(3C) 价值教育理念：</p>
							<span>品格（Character）、<br>   多元文化（Culture）、<br>   创造力（Creativity）</span>
						</li>
						<li class="five">
							<p>(5大) 核心优势：</p>
							<span>品牌号召力、教学教研能力、<br>   运营管理能力、线下示范园展示能力、<br>    信息技术开发能力</span>
						</li>
						<li class="seventao">
							<p>(7套) 产品体系：</p>
							<span>品牌认证体系、运营管理体系、<br>   综合培训体系、课程教学体系、<br>   信息产品体系、增值服务体系、   </span>
						</li>
					</ul>
				</div>
			</div>
			<div class="seven">
				<div class="partitle">
					<h4>七大体系介绍</h4>
					<img src="../assets/partner/seven_title.png" alt="">
					<span class="partitle-bor"></span>
				</div>
				<div class="seven-cont">
					<ul class="seven-nav">
						<li v-for="(item, index) in items" :key="index" @mouseenter="handleSeven(index)" :class="{active:index===activeIndex}">{{item.text}}</li>
					</ul>
					<div class="seven-list" v-for="(el, _index) in lists" :key="_index" v-show="_index===activeIndex">
						<h4><img :src="el.titleUrl" alt=""></h4>
						<div class="seven-list-cont">
							<p>{{el.cont}}</p>
							<img :src="el.imgUrl" alt="">
						</div>
					</div>
				</div>
			</div>
			<div class="adv">
				<div class="adv-width">
					<div class="partitle">
						<h4>成为合伙人的优势</h4>
						<img src="../assets/partner/adv_title.png" alt="">
						<span class="partitle-bor"></span>
					</div>
					<ul class="adv-cont">
						<li>KA依托蒙台梭利百年教育理念，Etonkids国际化研发、教学、运营、管理团队背景，以及17年来双语国际化教学的积累，逐渐形成了国际化优势并实现了与中国教育体系的完美融合。</li>
						<li class="ml-one">KA提供严选的服务、产品及供应链，全方位的质量标准体系、流程化的运营管理体系、全球化的认证及培训体系、17年高端园所教育管理经验，确保各项产品及服务在品质上的领先。</li>
						<li class="ml-two">KA所具备3C价值教育理念、独特的家长大学产品、有针对性的测评体系、多样的教学手段、丰富的课外课程体系、融合式的中西方教育方法可以最大程度满足不同用户的个性化需求。</li>
						<li class="ml-thr">KA提供的是一套完整的服务，涵盖了品牌认证、课程教学、运营管理、综合培训、信息系统、增值课外课及家长大学服务，能够系统化的解决园所的各类问题，系统化的满足各类需求。</li>
					</ul>
				</div>
			</div>
			<div class="coo">
				<div class="partitle">
					<h4>合作流程</h4>
					<img src="../assets/partner/coo_title.png" alt="">
					<span class="partitle-bor"></span>
				</div>
			</div>
			<div class="process">
				<div class="partitle">
					<h4>运营服务流程</h4>
					<img src="../assets/partner/process_title.png" alt="">
					<span class="partitle-bor"></span>
				</div>
				<img class="process-pic" src="../assets/partner/process_img.png" alt="">
			</div>
			<div class="join">
				<div class="join-cont">
					<h2>加入我们</h2>
					<img src="../assets/partner/join_us.png" alt="">
					<p>咨询电话</p>
					<span></span>
				</div>
			</div>
			<div class="apply">
				<h4>申请获取《园所经营宝典》</h4>
				<Apply />
			</div>
		</div>
	</div>
</template>
<script>
	import ApplyForm from '@/components/Common/ApplyForm'
	export default {
		name: 'Pomelo',
		components: {
			'Apply': ApplyForm
		},
		data () {
			return {
				activeIndex: 0,
				flag: 0,
				items: [
					{text: '品牌认证体系'},
					{text: '运营管理体系'},
					{text: '综合培训体系'},
					{text: '课程教学体系'},
					{text: '信息产品体系'},
					{text: '增值服务体系'},
					{text: '家长大学体系'},
				],
				lists: [
					{
						titleUrl: require('../assets/partner/seven_en01.png'), 
						cont: '凡合作园所在合同期内均可经KA授权，享有KA的权威认证铭牌及标识，以及整套VI设计模板。', 
						imgUrl: require('../assets/partner/seven_img01.png')},
					{
						titleUrl: require('../assets/partner/seven_en02.png'), 
						cont: '在园所筹建运营过程中，为合伙人提供筹备、建设、开业和运营等各个阶段的专业化标准服务，让非行业内投资人可以顺利建成高标准园所。', 
						imgUrl: require('../assets/partner/seven_img02.png')},
					{
						titleUrl: require('../assets/partner/seven_en03.png'), 
						cont: '以打造国际化园所为目标，以线上线下的多方位立体学习方式为投资人、园长、教师等多岗位进行培训，为KA合伙人园所的筹建和运营保驾护航。<br>培训内容覆盖面广、学术储备深厚，从整体框架到细节演示，面面俱到，并邀请国内外多位学术专家泰斗进行授课，充分满足不同类型合伙人，不同运作阶段的需求。', 
						imgUrl: require('../assets/partner/seven_img03.png')},
					{
						titleUrl: require('../assets/partner/seven_en04.png'), 
						cont: '遵循幼儿发展规律，运用先进的教育理念，为合伙人提供完整的可激发幼儿发展潜力的中高端课程体系，配套完善的培训教研服务，保证园所教学质量。', 
						imgUrl: require('../assets/partner/seven_img04.png')},
					{
						titleUrl: require('../assets/partner/seven_en05.png'), 
						cont: '高度契合园所管理需求。通过SaaS系统与手机客户端覆盖三大用户端，众多模块集于一身，数据实时互通，掌握园所动态。', 
						imgUrl: require('../assets/partner/seven_img05.png')},
					{
						titleUrl: require('../assets/partner/seven_en06.png'), 
						cont: 'KA教育科学与发展研究院以3C教育理念结合园所实际需求进行研发和资源整合，为合伙人提供各类资源，丰富园所教学体系，增强园所核心竞争力，让园所在延时服务中获得更好的口碑。', 
						imgUrl: require('../assets/partner/seven_img06.png')},
					{
						titleUrl: require('../assets/partner/seven_en07.png'), 
						cont: '家长才是孩子最好的老师', 
						imgUrl: require('../assets/partner/seven_img07.png')},
				]
			}
		},
		methods: {
			handleSeven: function(index) {
				this.activeIndex = index;
			}
		}
		
		
	}
</script>
<style lang="scss" scoped>
	@import '../base/scss/mixin';
	.wrap {
		padding-top: 70px;
		padding-bottom: 40px;
	}
	.partitle {
		text-align: center;
		h4 {
			letter-spacing: 3px;
			font-weight: normal;
			font-size: 28px;
			color: #1c50a1;
		}
		&-bor {
			width: 160px;
			height: 8px;
			display: block;
			margin: 0 auto;
			background: #e8374a;
		}
	}
	.intro {
		height: 966px - 52px;
		padding-top: 52px;
		background: url(../assets/partner/intro.png) no-repeat center top #fff;
		.cwidth {
			@extend %clearfix;
		}
		.partitle {
			text-align: left;
			h4 {
				margin-bottom: 12px;
			}
			img {
				margin-bottom: 22px;
			}
		}
		&-l {
			padding-left: 52px;
			float: left;
		}
		&-r {
			float: right;
			padding-top: 108px;
			li {
				letter-spacing: 2px;
				line-height: 25px;
			}
			p {
				font-size: 16px;
			}
			span {
				font-size: 14px;
			}
			.one {
				margin-bottom: 56px;
				color: #2aafce;
			}
			.three {
				margin-bottom: 188px;
				color: #7b3d8f;
			}
			.five {
				margin-bottom: 132px;
				color: #de88b0;
			}
			.seventao {
				color: #f1aa00;
			}
		}
		&-txt {
			width: 315px;
			padding-bottom: 16px;
			border-bottom: 4px solid #1C50A1;
			margin-bottom: 46px;
			p {
				letter-spacing: 1px;
				text-align: justify;
				line-height: 26px;
				font-size: 14px;
				color: #111b3d;
			}
		}
	}
	.seven {
		height: 670px;
		background: url(../assets/partner/seven_bg.png) center top no-repeat;
		.partitle {
			margin-bottom: 70px;
			h4 {
				margin-bottom: 15px;
			}
			img {
				margin-bottom: 6px;
			}
		}
		&-cont {
			width: 1055px;
			margin-left: auto;
			margin-right: auto;
			height: 410px;
			overflow: hidden;
			position: relative;
		}
		&-nav {
			// float: left;
			li {
				width: 300px;
				@include lh(50px);
				background: #274e9a;
				margin-bottom: 10px;
				transition: all ease .35s;
				cursor: pointer;
				font-size: 22px;
				color: #fff;
			}
			.active {
				background: #e8374a;
				box-shadow: 2px 3px 6px rgba(131,152,185,.6);
			}
		}
		&-list {
			position: absolute;
			right: 0;
			top: 0;
			width: 740px - 4px;
			height: 410px - 4px;
			background: #fff;
			border: 2px solid #a6a6a6;
			&-cont {
				width: 670px;
				margin: 0 auto;
				img {
					display: block;
					margin: 20px auto 0;
				}
				
			}
			&:nth-of-type(4),
			&:nth-of-type(6){
				.seven-list-cont {
					img {
						margin-top: 60px;
					}
				}
			}
			&:nth-of-type(5) {
				.seven-list-cont {
					img {
						margin-top: 40px;
					}
				}
			}
			
			h4 {
				@include lh(46px);
				background: #ededed;
				margin-bottom: 26px;
				img {
					vertical-align: middle;
				}
			}
			p {
				// margin-bottom: 20px;
				line-height: 26px;
				font-size: 16px;
				color: #111b3d;
			}
		}
// 		.seven-brand,
// 		.seven-oper,
// 		.seven-curr,
// 		.seven-online,
// 		.seven-value,
// 		.seven-parents,
// 		.seven-train {
// 			
// 			
// 		}
	}
	.adv {
		height: 890px;
		background: url(../assets/partner/adv_bg.png) center top no-repeat;
		&-width {
			width: 1040px;
			margin: 0 auto;
			position: relative;
		}
		.partitle {
			text-align: center;
			h4 {
				margin-bottom: 15px;
			}
			img {
				margin-bottom: 10px;
			}
		}
		&-boy {
			position: absolute;
			right: 54px;
			top: -448px;
		}
		&-cont {
			padding-top: 100px;
			padding-left: 200px;
			li {
				width: 360px;
				height: 150px;
				text-align: justify;
				line-height: 24px;
				font-size: 14px;
				color: #111b3d;
			}
			.ml-one {
				margin-left: 160px;
			}
			.ml-two {
				margin-left: 100px;
			}
			.ml-thr {
				margin-left: 276px;
			}
		}
	}
	.coo {
		height: 1060px;
		background: url(../assets/partner/coo_bg.png) center top no-repeat;
		.partitle {
			h4 {
				margin-bottom: 12px;
			}
			img {
				margin-bottom: 10px;
			}
		}
	}
	.process {
		height: 426px;
		background: url(../assets/partner/bg.jpg) center top repeat-y;
		.partitle {
			margin-bottom: 58px;
			h4 {
				margin-bottom: 15px;
			}
			img {
				margin-bottom: 10px;
			}
		}
		&-pic {
			display: block;
			margin: 0 auto;
		}
	}
	.join{
		height: 324px;
		background: url(../assets/partner/joinus.jpg) center top no-repeat;
		&-cont {
			padding-top: 38px;
			text-align: center;
			color: #fff;
			h2 {
				display: inline-block;
				margin-bottom: 6px;
				padding-bottom: 10px;
				border-bottom: 7px solid #1a58a2;
				font-weight: normal;
				font-size: 36px;	
			}
			p {
				margin-bottom: 4px;
				font-size: 30px;
			}
			span {
				font-size: 60px;
			}
			img {
				display: block;
				margin: 0 auto 42px;
			}
		}
	}
	.apply {
		padding-top: 60px;
		background: url(../assets/partner/bg.jpg) repeat-y center top;
		h4 {
			margin-bottom: 30px;
			text-align: center;
			font-weight: normal;
			font-size: 30px;
			color: #1a58a2;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/Partner.vue